import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ChamadoFranquiaInserirComponent } from './chamado-franquia-inserir.component';

const routes: Routes = [];

@NgModule({
  imports: [RouterModule.forChild([
    {path: '', component: ChamadoFranquiaInserirComponent}
  ])],
  exports: [RouterModule]
})
export class ChamadoFranquiaInserirRoutingModule { }
